import React, { useState, useEffect } from 'react';
import BackNavbar from '../../../ReusableBlocks/Navbar';
import Footer from '../../../ReusableBlocks/FooterBlock';
import { useParams } from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const Content_Store_FIles_Det = () => {
    return (
        <>
            <BackNavbar />
            <section className='playbook-view-popup'>
                <div className="container">
                    <div className='modal-div-learning'>
                        <div className="row">
                            <div className="col-sm-8 mb-3 mb-sm-0">
                                <div className="file-container">
                                    <iframe
                                        src=""
                                        frameBorder="0"
                                        width="100%"
                                        height="100%"
                                        allowFullScreen
                                        title="File Preview"
                                    ></iframe>
                                </div>
                            </div>
                            <div className="col-sm-4 mb-3 mb-sm-0">
                                <div className="file-controls-dive">
                                    <h1 className='file-tite-des'>Title</h1>
                                    <div className="line"></div>

                                    <p className='file-p-des'>Password:
                                        <span
                                            // onClick={() => copyToClipboard('Playbook@123')}
                                            style={{ cursor: 'pointer' }}
                                            className='new-passowrd'
                                        >
                                            Copy Password
                                        </span>
                                    </p>

                                    <button className='card-cat-cancel'
                                    //  onClick={handleBack}
                                    >
                                        Back to Narrative
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
           
        </>
    )
}

export default Content_Store_FIles_Det